import React from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserProfileData } from '../UserProfileForm';

const GARDEN_GOALS = ['Self-Sufficiency', 'Optimize Yield', 'Aesthetics', 'Pollinator Friendly', 'Education', 'Low Maintenance', 'Grow from Seed', 'Harvest Own Seeds', 'Organic Practices', 'Rare Varieties'];

interface StepPrioritiesProps {
    data: Partial<UserProfileData>;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onGoalsChange: (goals: string[]) => void;
}

export const StepPriorities: React.FC<StepPrioritiesProps> = ({ data, onChange, onGoalsChange }) => {
    const { t } = useTranslation();

    const handleGoalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const currentGoals = data.gardenGoals || [];
        const newGoals = e.target.checked
            ? [...currentGoals, value]
            : currentGoals.filter(g => g !== value);
        onGoalsChange(newGoals);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom sx={{ textAlign: 'left' }}>
                {t('onboarding.priorities_title')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'left' }}>
                {t('onboarding.priorities_subtitle')}
            </Typography>

            {/* Garden Goals */}
            <Box sx={{ mb: 3 }}>
                <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" sx={{ textAlign: 'left' }}>{t('settings.main_goals')}</FormLabel>
                    <FormGroup sx={{ mt: 1 }}>
                        {GARDEN_GOALS.map(goal => (
                            <FormControlLabel
                                key={goal}
                                control={
                                    <Checkbox
                                        checked={(data.gardenGoals || []).includes(goal)}
                                        onChange={handleGoalChange}
                                        value={goal}
                                    />
                                }
                                label={t(`settings.goals.${goal.toLowerCase().replace(/[\s-]/g, '_')}`)}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            </Box>

            <TextField
                label={t('settings.weekly_availability')}
                name="availability"
                value={data.availability || ''}
                onChange={onChange}
                fullWidth
                margin="normal"
                helperText={t('settings.availability_helper')}
            />
        </Box>
    );
};
